import errorsLogger from 'utils/errors-logger';
const FEATURE = 'closet_item';
export const logClosetItemError = errorsLogger(FEATURE);